export const GOOGLE_OAUTH_CLIENT_ID =
  "555870411110-6h9g25v8494l2arl7dmqtckhd5sj2f89.apps.googleusercontent.com";

export const USER_TYPES = {
  CUSTOMERS: "CUSTOMERS",
  SUBSCRIBERS: "SUBSCRIBERS",
};
export const plans = [
  {
    features: [
      "Dynamic pricing",
      "Paid Search",
      "Metasearch Marketing",
      "Standard Reporting",
    ],
    planName: "Lite",
    price: "999",
    type: "ST",
    planStyle:
      "text-brand-secondary bg-pink-light border-pink-primary shadow-soft",
    description:
      "The basics of digital marketing and dynamic pricing to increase awareness and drive more direct bookings.",
  },
  {
    features: [
      "Everything on Lite plan",
      "OTA Optimization",
      "Website",
      "Booking Engine",
    ],
    price: "1,299",
    planName: "Professional",
    isRecommended: true,
    type: "PR",
    planStyle:
      "text-info bg-info-light border-info shadow-soft",
    description:
      "A comprehensive all-in-one solution that automates everything, with unlimited access to our Revenue CoPilot.",
  },
  {
    price: "2,499",
    planName: "Full-Service",
    type: "MX",
    planStyle:
      "text-info bg-info-light border-info-light shadow-soft",
    description:
      "All of our software plus one of our certified revenue specialists will set-up & carefully oversee everything for you.",
    features: [
      "Everything on Professional plan",
      "Custom Website",
      "Dedicated Revenue Manager",
      "Monthly Review Meetings",
    ],
  },
];
